import AttachFile from '@mui/icons-material/AttachFile';
import DeleteIcon from '@mui/icons-material/Delete';
import {
	FormLabel,
	IconButton,
	List,
	ListItem,
	ListItemIcon,
	ListItemText,
	Stack,
} from '@mui/material';
import React from 'react';
import { getFileDisplayName, removeFileFromSelection } from './helpers';

const SelectedFilesList = ({ selectedFiles, onChange }) => {
	if (selectedFiles.length === 0) return null;

	const handleRemoveFile = (fileToRemove) => {
		onChange(removeFileFromSelection(selectedFiles, fileToRemove));
	};

	return (
		<Stack spacing={1}>
			<FormLabel>Selected files ({selectedFiles.length})</FormLabel>
			<List dense>
				{selectedFiles.map((file, index) => (
					<ListItem
						disablePadding
						key={`${file.id ?? file.name}_${index}`}
						secondaryAction={
							<IconButton
								edge='end'
								aria-label='delete'
								onClick={() => handleRemoveFile(file)}
							>
								<DeleteIcon />
							</IconButton>
						}
					>
						<ListItemIcon sx={{ minWidth: 36 }}>
							<AttachFile />
						</ListItemIcon>
						<ListItemText primary={getFileDisplayName(file.name)} />
					</ListItem>
				))}
			</List>
		</Stack>
	);
};

export default SelectedFilesList;
